import dayjs from 'dayjs';
import { InternalApiFinalRisk, InternalApiFinalRiskEventEnum } from '../api-internal';

export type RiskHistoryDateRange = '7' | '30' | '90' | 'ALL';
export type RiskHistoryEventType = 'ALL' | 'SCORE_CHANGE' | 'OVERRIDE';

export const DEFAULT_RISK_HISTORY_DATE_RANGE: RiskHistoryDateRange = 'ALL';
export const DEFAULT_RISK_HISTORY_EVENT_TYPE: RiskHistoryEventType = 'ALL';

const matchesEventType = (event: InternalApiFinalRisk, eventType: RiskHistoryEventType): boolean => {
  if (eventType === 'SCORE_CHANGE') {
    return event.event === InternalApiFinalRiskEventEnum.SCORE_CHANGED;
  } else if (eventType === 'OVERRIDE') {
    return (
      event.event === InternalApiFinalRiskEventEnum.OVERRIDE_STARTED ||
      event.event === InternalApiFinalRiskEventEnum.OVERRIDE_ENDED
    );
  } else if (eventType === 'ALL') {
    return true;
  } else throw new Error('Unknown event type');
};

const isWithinDateRange = (event: InternalApiFinalRisk, dateRange: RiskHistoryDateRange): boolean => {
  if (dateRange === 'ALL') return true;
  return !dayjs(event.createdTime).isBefore(dayjs().subtract(Number(dateRange), 'day'));
};

export const filterRiskHistory = (
  events: InternalApiFinalRisk[],
  dateRange: RiskHistoryDateRange,
  eventType: RiskHistoryEventType
): InternalApiFinalRisk[] =>
  events.filter((event) => isWithinDateRange(event, dateRange) && matchesEventType(event, eventType));
